module.exports = __webpack_public_path__ + "img/location-carousel-slide.f7184436.png";